import { auth } from "../firebase";

// MaviinciAI ke staff endpoints (bookings, qr-payments, settings) ab bina
// pehchaan ke jawab nahi dete. Admin panel ka apna Firebase login hi chabi hai:
// uska ID token bhejte hain, aur server check karta hai ki email uski
// ADMIN_EMAILS list me hai (wahi jo firestore.rules ki chabi() list hai).
export async function aiAuthFetch(url, options = {}) {
    const headers = { ...(options.headers || {}) };
    const user = auth.currentUser;
    if (user) headers.Authorization = `Bearer ${await user.getIdToken()}`;
    return fetch(url, { ...options, headers });
}
